<template>
  <div v-if="limitVariants" class="per-page d-flex align-items-center">
    <div class="title">
      {{$t("Rows per page:")}}
    </div>
    <b-form-select
      v-model="pagination.limit"
      @change="limitChange"
      size="sm"
      :options="limitVariants"/>
  </div>
</template>

<script>

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    props: {
      pagination: Object,
      limitVariants: {
        type: Array,
        default: () => [5, 10, 25, 50, 200],
      }
    },
    methods: {
      limitChange(selected) {
        this.$emit('limitChange', selected)
      },
    }
  }
</script>

<style lang="scss" scoped>
  .title {
    width: 8em;
  }
  select {
    width: 5.5em;
  }
</style>
